import React from "react";
import "./NotFoundComponent.scss";

class NotFoundComponent extends React.Component {
  render() {
    return (
      <div className="f404-page">
        <div className="f404-container">
          <div className="f404-content">
            <div className="f404">
              <div className="ocean">
                <img 
                  src="https://fbtsdev.blob.core.windows.net/survey/Thaipost/logo-thaipost.png"
                  alt="thaipost"
                />
              </div>
              <div className="text">
                <div className="t3">
                  <div>ขออภัยค่ะ</div>

                  <div>ท่านได้ทำการตอบแบบสอบถามแล้ว</div>

                  <div>ขอขอบคุณสำหรับความคิดเห็นของท่านที่จะช่วยให้ไปรษณีย์ไทยนำไปพัฒนาบริการให้ดียิ่งขึ้นต่อไป</div>

                  <div>หากมีข้อสงสัยสามารถติดต่อศูนย์บริการลูกค้า<span>ไปรษณีย์ได้ที่ 1545</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFoundComponent;
